import React, { useState, useEffect } from 'react';
import './ExpirationCountdown.css';

export default function ExpirationCountdown({ expiresAt, showLabel = true }) {
  const [timeLeft, setTimeLeft] = useState('');
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    if (!expiresAt) {
      setTimeLeft('');
      return;
    }

    const updateCountdown = () => {
      const now = Date.now();
      const expiry = expiresAt instanceof Date ? expiresAt.getTime() : new Date(expiresAt).getTime();
      const diff = expiry - now;

      if (diff <= 0) {
        setTimeLeft('Expired');
        setIsExpired(true);
        return;
      }

      const minutes = Math.floor(diff / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      if (minutes > 0) {
        setTimeLeft(`${minutes}m ${seconds}s`);
      } else {
        setTimeLeft(`${seconds}s`);
      }
      setIsExpired(false);
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [expiresAt]);

  if (!expiresAt || !timeLeft) {
    return null;
  }

  return (
    <div className={`expiration-countdown ${isExpired ? 'expired' : ''}`} aria-live="polite" aria-label={`Room ${isExpired ? 'expired' : 'expires in'} ${timeLeft}`}>
      {showLabel && <span className="countdown-label">Expires in:</span>}
      <span className="countdown-time">{timeLeft}</span>
    </div>
  );
}
